import React, { Component } from 'react';

export default class SectionThree extends Component {
  render() {
    return       <section class="home-4 section overflow-hidden" id="explore">
    <div class="container ">
      <div class="row justify-content-center">
        <div class="col-lg-8 ">
          <div class="text-center pb-5 home-heading">
            <h6 class="fw-semibold text-muted">Discover digital art and collect NFTs</h6>
            <h2 class="fw-bold">Our Best Template for NFT Marketplace</h2>
            <p class=" text-muted">Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio sunt
              expedita dolor <br /> illum illo cumque. Repudiandae harum doloribus reiciendis.</p>
          </div>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-lg-3">
          <div class="border-horizontal"></div>
          <div class="home-image-gallery ">
            <div class="row">
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-1.png" alt="" class="img-fluid" />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="mt-4">
                  <img src="images/blog-3/img-2.png" alt="" class="img-fluid" />
                </div>
              </div>
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-3.png" alt="" class="img-fluid" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-4.png" alt="" class="img-fluid" />
                </div>
              </div>
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-5.png" alt="" class="img-fluid" />
                </div>
              </div>
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-6.png" alt="" class="img-fluid" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-7.png" alt="" class="img-fluid" />
                </div>
              </div>
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-8.png" alt="" class="img-fluid" />
                </div>
              </div>
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-1.png" alt="" class="img-fluid" />
                </div>
              </div>
            </div>
            <div class="row mb-0 mb-lg-4">
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-3.png" alt="" class="img-fluid" />
                </div>
              </div>
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-6.png" alt="" class="img-fluid" />
                </div>
              </div>
              <div class="col-sm-4 ">
                <div class="mt-4">
                  <img src="images/blog-3/img-4.png" alt="" class="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="row align-items-center">
            <div class="col-lg-5 col-md-6 my-4 my-lg-0">
              <div class="art-image p-lg-4">
                <img src="images/img1.jpg" alt="" class="img-fluid" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="body-content">
                <div class="d-flex">
                  <div class="title">
                    <h4 class="fw-bold text-uppercase">Own Collection</h4>
                  </div>
                  <div class="icon d-flex ms-auto">
                    <div class="like">
                      <a href=""><i class="mdi mdi-heart"></i></a>
                    </div>
                    <div class="menu ms-3">
                      <div class="dropdown">
                        <a href="" id="dropdownMenuButton1" data-bs-toggle="dropdown"
                          aria-expanded="false"><i class="mdi mdi-dots-vertical">
                          </i></a>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                          <li><a class="dropdown-item" href="#">Action</a></li>
                          <li><a class="dropdown-item" href="#">Another action</a></li>
                          <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-content">
                  <div class="small-title mb-3">
                    <p class="f-14 fw-semibold">0.24 ETH <span class="text-muted ms-2">$246.13 1 of
                      1</span></p>
                  </div>
                  <div class="info-list">
                    <p class="f-14 text-muted fw-semibold mb-0">Artist : <span>mickel_fenn</span>
                    </p>
                    <p class="f-14 text-muted fw-semibold mb-0">Size : <span>3000 × 3000</span></p>
                    <p class="f-14 text-muted fw-semibold">Created : <span>02 April, 2021</span></p>
                  </div>
                  <div class="profile mt-4">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0">
                        <div class="avatar-md">
                          <img src="images/slider/user/img-1.jpg" alt=""
                            class="img-fluid rounded-circle" />
                        </div>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h6 class="f-14 text-muted mb-0">Owner</h6>
                        <p class="f-14 mb-0 fw-semibold">jimmy_dom </p>
                      </div>
                    </div>
                  </div>
                  <div class="high-bid p-4 mt-4">
                    <h6>Highest Bid:</h6>
                    <div class="d-flex">
                      <div class="avatar-xs bg-primary rounded-circle text-center text-white">M
                      </div>
                      <div class="text ms-auto">
                        <p class="mb-0 f-14 fw-semibold">2.51 ETH $314.00</p>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex mt-4">
                    <button class="btn btn-primary rounded-pill">Buy now</button>
                    <div class="ms-2">
                      <button class="btn btn-outline-primary rounded-pill">Buy now</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>;
  }
}
